import { render, staticRenderFns } from "./WaiterPerformance.vue?vue&type=template&id=3be2fae9&scoped=true"
import script from "./WaiterPerformance.vue?vue&type=script&lang=js"
export * from "./WaiterPerformance.vue?vue&type=script&lang=js"
import style0 from "./WaiterPerformance.vue?vue&type=style&index=0&id=3be2fae9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be2fae9",
  null
  
)

export default component.exports